import AddIcon from "@mui/icons-material/AddRounded";
import { Button } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import GeneralPageHeader from "../../common/GeneralPageHeader";
import InvestorCommunicationsPageContext from "./InvestorCommunicationsPageContext";

const InvestorCommunicationsPageHeader = () => {
  const { hasEditPermissions, onCreate } = useDefinedContext(
    InvestorCommunicationsPageContext,
    "InvestorCommunicationsPageContext"
  );

  return (
    <GeneralPageHeader title="Investor Communications">
      {hasEditPermissions && (
        <Button variant="contained" startIcon={<AddIcon />} onClick={onCreate}>
          New
        </Button>
      )}
    </GeneralPageHeader>
  );
};

export default InvestorCommunicationsPageHeader;
